
export const EDIT_MOD_VERSION_LABEL = "Укажите версию мода"

export const EDIT_MOD_VERSION_LABEL_TEXT = "Только номер версии. Например 2.5"
